
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.933 14.8H9.467L5.2 18v-3.2H3.067A1.067 1.067 0 012 13.733V3.067A1.067 1.067 0 013.067 2h13.866A1.067 1.067 0 0118 3.067v10.666a1.067 1.067 0 01-1.067 1.067zM5.2 6.8h9.6M5.2 10h7.467","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    